import { defineComponent, createElementBlock, openBlock, normalizeStyle, normalizeClass, unref, createElementVNode, Fragment, renderList, createBlock } from 'vue';
import _sfc_main$1 from './basler-components.es179.js';
/* empty css                        */
import { useBlockPositioning } from './basler-components.es364.js';

const _hoisted_1 = { class: "image-text-teasers-block__inner" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ImageTextTeasersBlock",
  props: {
    teasers: { default: () => [] },
    cols: { default: 12 },
    colsCentered: { type: Boolean, default: true },
    contentCentered: { type: Boolean, default: false },
    isImageStretched: { type: Boolean },
    isRounded: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const { positioningClassNames } = useBlockPositioning(
      "image-text-teasers-block",
      props.cols,
      props.colsCentered,
      props.contentCentered
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "image-text-teasers-block",
          unref(positioningClassNames),
          `image-text-teasers-block--items-${props.teasers.length}`
        ]),
        style: normalizeStyle(`--cols: ${props.cols}`)
      }, [
        createElementVNode("div", _hoisted_1, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.teasers, (teaser, index) => {
            return openBlock(), createBlock(_sfc_main$1, {
              teaser,
              "is-image-stretched": props.isImageStretched,
              "is-rounded": props.isRounded,
              key: index
            }, null, 8, ["teaser", "is-image-stretched", "is-rounded"]);
          }), 128))
        ])
      ], 6);
    };
  }
});

export { _sfc_main as default };
